import * as actions from '../actionTypes'

const initialState = {
  driverInformation: {
    typeRoadTest: 'select',
    masterNumber: '',
    driverFirstName: '',
    driverLastName: '',
    dateOfBirth: '',
    emailAddress: '',
    confirmEmailAddress: '',
    phoneNumber: '',
    masterNumberDOB: '',
  },
}

const DriverInformationReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.TYPE_ROAD_TEST: {
      return {
        ...state,
        driverInformation: {
          ...state.driverInformation,
          typeRoadTest: action.payload.description,
        },
      }
    }
    case actions.MASTER_NUMBER: {
      return {
        ...state,
        driverInformation: {
          ...state.driverInformation,
          masterNumber: action.payload.description,
        },
      }
    }
    case actions.DRIVER_FIRST_NAME: {
      return {
        ...state,
        driverInformation: {
          ...state.driverInformation,
          driverFirstName: action.payload.description,
        },
      }
    }
    case actions.DRIVER_LAST_NAME: {
      return {
        ...state,
        driverInformation: {
          ...state.driverInformation,
          driverLastName: action.payload.description,
        },
      }
    }
    case actions.DATE_OF_BIRTH: {
      return {
        ...state,
        driverInformation: {
          ...state.driverInformation,
          dateOfBirth: action.payload.description,
        },
      }
    }
    case actions.EMAIL_ADDRESS: {
      return {
        ...state,
        driverInformation: {
          ...state.driverInformation,
          emailAddress: action.payload.description,
        },
      }
    }
    case actions.CONFIRM_EMAIL_ADDRESS: {
      return {
        ...state,
        driverInformation: {
          ...state.driverInformation,
          confirmEmailAddress: action.payload.description,
        },
      }
    }
    case actions.PHONE_NUMBER: {
      return {
        ...state,
        driverInformation: {
          ...state.driverInformation,
          phoneNumber: action.payload.description,
        },
      }
    }
    case actions.MASTER_NUMBER_DOB: {
      return {
        ...state,
        driverInformation: {
          ...state.driverInformation,
          masterNumberDOB: action.payload.description,
        },
      }
    }
    case actions.CLEAR_ALL_FIELDS: {
      return initialState
    }
    case actions.CLEAR_ALL: {
      return initialState
    }
    default: {
      return state
    }
  }
}
export default DriverInformationReducer
